import Loadable from 'react-loadable';

import LoadingIndicator from 'components/LoadingIndicator';

export default Loadable({
  loader: () =>
    import(
      '../CostcoWaterCASupplyChain' /* webpackChunkName: "CostcoWaterCASupplyChain" */
    ),
  loading: LoadingIndicator,
});
